/* Alba Stella — theme scripts */
(function () {
  'use strict';
  var C = window.Alba || {};
  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var isDesktop = function () { return window.matchMedia('(min-width: 769px)').matches; };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || C.moneyFormat || '€{{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(placeholder, value);
  }
  C.formatMoney = formatMoney;

  /* ---------- Overlay / drawers / modals ---------- */
  var overlay = qs('[data-overlay]');
  var openLayer = null;
  function lock() { document.body.classList.add('drawer-is-open'); }
  function unlock() { document.body.classList.remove('drawer-is-open'); }
  function openDrawer(name) {
    var el = qs('[data-drawer="' + name + '"]');
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    openLayer = el;
    lock();
  }
  function openModal(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    openLayer = el;
    lock();
  }
  function closeAll() {
    qsa('.drawer.is-open, .modal.is-open, .search-modal.is-open, .header-search.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-visible');
    qsa('.pdp-videos__video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    openLayer = null;
    unlock();
  }
  C.openDrawer = openDrawer;
  C.closeAll = closeAll;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (t.closest('[data-drawer-close]') || t.closest('[data-modal-close]') || t.closest('[data-overlay]')) { e.preventDefault(); closeAll(); return; }
    if (t.classList && t.classList.contains('modal')) { closeAll(); return; }
    var cartOpener = t.closest('[data-cart-open]');
    if (cartOpener) { e.preventDefault(); openDrawer('cart'); return; }
    var searchOpener = t.closest('[data-search-open]');
    if (searchOpener) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-search-close]')) { e.preventDefault(); closeAll(); return; }
    var qv = t.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); openQuickView(qv.getAttribute('data-quick-view')); return; }
    var sg = t.closest('[data-size-guide-open]');
    if (sg) { e.preventDefault(); openModal(qs('[data-size-guide]')); return; }
    var st = t.closest('[data-scroll-top]');
    if (st) {
      var target = qs('[data-bundle]') || qs('[data-product-form]') || qs('#MainContent');
      if (target) { e.preventDefault(); window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' }); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openLayer) closeAll(); });

  /* ---------- Search (bar over the header box + predictive results, Impulse style) ---------- */
  var searchModal = qs('[data-search-container]');
  var searchTimer = null;
  var searchSeq = 0;
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function placeSearch() {
    var header = qs('[data-header]');
    if (!header || !searchModal) return;
    var r = header.getBoundingClientRect();
    searchModal.style.setProperty('--search-top', r.top + 'px');
    searchModal.style.setProperty('--search-h', r.height + 'px');
  }
  function openSearch() {
    closeAll();
    if (!searchModal) return;
    placeSearch();
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    openLayer = searchModal;
    lock();
    var input = qs('[data-search-input]', searchModal);
    if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
  }
  C.openSearch = openSearch;
  if (searchModal) {
    var sInput = qs('[data-search-input]', searchModal);
    var sResults = qs('[data-search-results]', searchModal);
    var arrowSvg = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false"><path d="M0 5h12.5M8.5 1l4 4-4 4" stroke="currentColor"/></svg>';
    var markTerm = function (text, term) {
      var i = text.toLowerCase().indexOf(term.toLowerCase());
      if (i < 0) return '<b>' + escapeHtml(text) + '</b>';
      var before = text.slice(0, i), hit = text.slice(i, i + term.length), after = text.slice(i + term.length);
      return (before ? '<b>' + escapeHtml(before) + '</b>' : '') + '<mark>' + escapeHtml(hit) + '</mark>' + (after ? '<b>' + escapeHtml(after) + '</b>' : '');
    };
    var thumbUrl = function (p) {
      var src = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    };
    var renderResults = function (term, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var queries = (res.queries || []).slice(0, 4), products = (res.products || []).slice(0, 4);
      var html = '';
      if (queries.length || products.length) {
        html += '<div class="search-results">';
        if (queries.length) {
          html += '<div class="search-results__group search-results__group--queries"><div class="search-results__box"><h3 class="search-results__heading">Suggesties</h3><ul class="search-results__list">';
          queries.forEach(function (q) {
            var href = q.url || ((C.routes.root || '/') + 'search?q=' + encodeURIComponent(q.text));
            html += '<li><a class="search-results__query" href="' + escapeHtml(href) + '"><span>' + markTerm(q.text || '', term) + '</span></a></li>';
          });
          html += '</ul></div></div>';
        }
        if (products.length) {
          html += '<div class="search-results__group search-results__group--products"><div class="search-results__box"><h3 class="search-results__heading">Producten</h3><ul class="search-results__list">';
          products.forEach(function (p) {
            var img = thumbUrl(p);
            html += '<li><a class="search-results__product" href="' + escapeHtml(p.url) + '"><span class="search-results__thumb">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span><span class="search-results__title">' + escapeHtml(p.title) + '</span></a></li>';
          });
          html += '</ul></div></div>';
        }
        html += '</div>';
      } else {
        html += '<div class="search-results search-results--empty"><p class="search-results__none">Geen resultaten voor “' + escapeHtml(term) + '”.</p></div>';
      }
      html += '<button type="submit" class="search-results__all">Bekijk alle resultaten voor “' + escapeHtml(term) + '” ' + arrowSvg + '</button>';
      sResults.innerHTML = html;
    };
    var runPredictive = function (term) {
      var seq = ++searchSeq;
      var url = (C.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,query&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (seq === searchSeq && sInput.value.trim() === term) renderResults(term, data); })
        .catch(function () {});
    };
    sInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var term = sInput.value.trim();
      if (!term) { searchSeq++; sResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { runPredictive(term); }, 200);
    });
    window.addEventListener('resize', function () { if (searchModal.classList.contains('is-open')) placeSearch(); });
  }

  /* ---------- Cart ---------- */
  var cartDrawer = qs('#CartDrawer');
  function refreshCart(open) {
    return fetch(window.location.pathname + '?sections=alba-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['alba-cart-drawer'];
        if (html && cartDrawer) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer-inner]');
          var current = qs('[data-cart-drawer-inner]', cartDrawer);
          if (fresh && current) current.replaceWith(fresh);
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa('[data-cart-bubble]').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
        if (open) openDrawer('cart');
        return cart;
      });
  }
  C.refreshCart = refreshCart;
  function addItems(items) {
    return fetch((C.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Toevoegen aan je winkelmand is niet gelukt. Probeer het opnieuw.');
        return data;
      });
    });
  }
  C.addItems = addItems;
  function changeLine(line, quantity) {
    if (cartDrawer) cartDrawer.classList.add('is-loading');
    return fetch((C.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(false); })
      .finally(function () { if (cartDrawer) cartDrawer.classList.remove('is-loading'); });
  }
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-cart-line'), 10);
      var input = qs('[data-qty-input]', row);
      var btn = e.target.closest('[data-qty-change]');
      if (btn) { e.preventDefault(); var q = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10)); changeLine(line, q); }
      if (e.target.closest('[data-qty-remove]')) { e.preventDefault(); changeLine(line, 0); }
    });
    cartDrawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var row = e.target.closest('[data-cart-line]');
      changeLine(parseInt(row.getAttribute('data-cart-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------- Variant helpers ---------- */
  function findVariant(product, options) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < options.length; j++) { if (options[j] != null && v.options[j] !== options[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- Classic product form (main + quick view) ---------- */
  function initProductMain(root) {
    if (!root || root.__albaInit) return;
    root.__albaInit = true;
    var jsonEl = qs('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = qs('[data-product-form]', root);
    var idInput = qs('[data-variant-id]', root);
    var atc = qs('[data-atc]', root);
    var atcLabel = qs('[data-atc-label]', root);
    var errorEl = qs('[data-form-error]', root);
    var track = qs('[data-gallery-track]', root);
    function selected() {
      return qsa('[data-option-index]', root).map(function (w) { var c = qs('input:checked', w); return c ? c.value : null; });
    }
    function update() {
      var opts = selected();
      qsa('[data-option-index]', root).forEach(function (w, i) { var lab = qs('[data-option-value]', w); if (lab) lab.textContent = opts[i] || ''; });
      var v = findVariant(product, opts);
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Niet beschikbaar'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'In winkelmand' : 'Uitverkocht';
      var p = qs('[data-price]', root); if (p) p.textContent = formatMoney(v.price);
      var c = qs('[data-compare]', root);
      if (c) { if (v.compare > v.price) { c.hidden = false; c.textContent = formatMoney(v.compare); } else { c.hidden = true; } }
      var s = qs('[data-savings]', root);
      if (s) { if (v.compare > v.price) { s.hidden = false; s.textContent = 'Bespaar ' + formatMoney(v.compare - v.price); } else { s.hidden = true; } }
      if (v.media && track) {
        var slide = qs('[data-media-position="' + v.media + '"]', track);
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      if (root.closest('.product-main') || root.hasAttribute('data-product-main')) {
        if (!root.hasAttribute('data-quick-view-content') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
        }
      }
    }
    qsa('[data-option-input]', root).forEach(function (i) { i.addEventListener('change', update); });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        atc.disabled = true;
        var qtyInput = qs('[name="quantity"]', form) || qs('[name="quantity"]', root);
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        addItems([{ id: parseInt(idInput.value, 10), quantity: qty }])
          .then(function () { closeAll(); return refreshCart(true); })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .finally(function () { atc.disabled = false; });
      });
    }
    qsa('[data-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var slide = qs('[data-slide="' + b.getAttribute('data-thumb') + '"]', root);
        qsa('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
  }
  qsa('[data-product-main]').forEach(initProductMain);

  /* ---------- Quick view ---------- */
  var qvModal = qs('#QuickViewModal');
  function openQuickView(url) {
    if (!qvModal) { window.location.href = url; return; }
    var content = qs('[data-modal-content]', qvModal);
    content.innerHTML = '<div style="padding:80px;text-align:center;">Laden…</div>';
    openModal(qvModal);
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { content.innerHTML = html; initProductMain(qs('[data-product-main]', content)); })
      .catch(function () { window.location.href = url; });
  }

  /* ---------- Card swatches ---------- */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-swatch-image]');
    if (!sw) return;
    var card = sw.closest('.grid-product');
    var img = card && qs('.grid-product__image--primary', card);
    if (img) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-swatch-image'); }
  });

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hotspot-btn]');
    var cards = qsa('[data-hotspot-card]');
    if (!btn) { if (!e.target.closest('[data-hotspot-card]')) { cards.forEach(function (c) { c.hidden = true; }); qsa('[data-hotspot-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); } return; }
    var card = qs('[data-hotspot-card]', btn.parentElement);
    var willOpen = card && card.hidden;
    cards.forEach(function (c) { c.hidden = true; });
    qsa('[data-hotspot-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (card && willOpen) {
      card.hidden = false; btn.setAttribute('aria-expanded', 'true');
      card.style.left = ''; card.style.right = ''; card.style.transform = '';
      var r = card.getBoundingClientRect();
      if (r.left < 8) { card.style.left = '0'; card.style.transform = 'translateX(-15%)'; }
      if (r.right > window.innerWidth - 8) { card.style.left = 'auto'; card.style.right = '0'; card.style.transform = 'translateX(15%)'; }
    }
  });

  /* ---------- Collection sort / filters ---------- */
  var sortSelect = qs('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () { var url = new URL(window.location.href); url.searchParams.set('sort_by', sortSelect.value); url.searchParams.delete('page'); window.location.href = url.toString(); });

  /* ---------- Footer collapsibles: closed on mobile, always open on desktop — also after a resize/rotation across 769 px
     (on desktop the summary is not clickable, so a menu closed at a narrow load width would otherwise stay hidden) ---------- */
  var footerMq = window.matchMedia('(min-width: 769px)');
  function syncFooterCollapsibles() {
    qsa('[data-footer-collapsible]').forEach(function (d) { if (footerMq.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  }
  syncFooterCollapsibles();
  if (footerMq.addEventListener) footerMq.addEventListener('change', syncFooterCollapsibles);
  else if (footerMq.addListener) footerMq.addListener(syncFooterCollapsibles);

  /* ---------- Help center search ---------- */
  var help = qs('[data-help-center]');
  if (help) {
    var hInput = qs('[data-help-search]', help);
    hInput.addEventListener('input', function () {
      var term = hInput.value.trim().toLowerCase(), any = false;
      qsa('[data-help-item]', help).forEach(function (item) {
        var match = !term || item.textContent.toLowerCase().indexOf(term) > -1;
        item.hidden = !match; if (match) any = true;
        if (term && match) item.setAttribute('open', '');
      });
      qs('[data-help-empty]', help).style.display = any ? 'none' : 'block';
    });
  }

  /* ---------- Recommendations ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Generic carousels (reasons, reviews) ---------- */
  qsa('[data-carousel]').forEach(function (car) {
    var track = qs('[data-carousel-track]', car);
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 16 : 300; }
    var prev = qs('[data-carousel-prev]', car), next = qs('[data-carousel-next]', car);
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Tabs ---------- */
  qsa('[data-tabs]').forEach(function (tabs) {
    qsa('[data-tab-btn]', tabs).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-tab-btn');
        qsa('[data-tab-btn]', tabs).forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        qsa('[data-tab-panel]', tabs).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== i; });
      });
    });
  });

  /* ---------- Video toggles ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-toggle]');
    if (!b) return;
    var v = qs('video', b.parentElement);
    if (!v) return;
    if (v.paused) { qsa('.pdp-videos__video').forEach(function (x) { if (x !== v) x.pause(); }); v.muted = false; v.play(); b.classList.add('is-playing'); }
    else { v.pause(); b.classList.remove('is-playing'); }
  });

  /* ---------- Announcement marquee: constant speed in px/s (Curvd: 44 px/s, 35.5 px/s at ≤480 px) ---------- */
  var marqueeTracks = qsa('[data-marquee-track]');
  function setMarqueeSpeed() {
    marqueeTracks.forEach(function (t) {
      var g = t.firstElementChild;
      if (!g) return;
      var w = g.getBoundingClientRect().width;
      if (w > 0) t.style.animationDuration = (w / (window.innerWidth <= 480 ? 35.5 : 44)).toFixed(2) + 's';
    });
  }
  if (marqueeTracks.length) {
    setMarqueeSpeed();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setMarqueeSpeed);
    var marqueeW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== marqueeW) { marqueeW = window.innerWidth; setMarqueeSpeed(); } });
  }

  /* ---------- Scroll reveal (Impulse AOS look): below-the-fold lazy images fade in, grid items fade in per column ---------- */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = window.Shopify && window.Shopify.designMode;
    if (reduce || editor || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight, vw = window.innerWidth;
    var pending = [];
    var reveal = function (el) {
      el.classList.add('is-in');
      el.addEventListener('animationend', function done() {
        el.removeEventListener('animationend', done);
        el.classList.remove('alba-fade', 'alba-row-item', 'is-in');
        el.style.removeProperty('--alba-delay');
      });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var i = pending.indexOf(en.target); if (i > -1) pending.splice(i, 1);
        reveal(en.target);
      });
    }, { rootMargin: '0px 0px -120px 0px' });
    var belowFold = function (el) { var r = el.getBoundingClientRect(); return r.top > vh && r.left >= 0 && r.left < vw; };
    var skip = '.drawer, .modal, .header-search, .site-header-wrap, .site-footer, [data-no-reveal]';
    var track = function (el) { pending.push(el); io.observe(el); };
    qsa('.product-grid, .collection-grid').forEach(function (grid) {
      if (grid.closest(skip)) return;
      Array.prototype.forEach.call(grid.children, function (item, i) {
        if (!belowFold(item)) return;
        item.style.setProperty('--alba-delay', ((i % 4) * 0.12).toFixed(2) + 's');
        item.classList.add('alba-row-item');
        track(item);
      });
    });
    qsa('img[loading="lazy"]').forEach(function (img) {
      if (img.closest(skip) || img.closest('.alba-row-item') || img.classList.contains('grid-product__image--secondary')) return;
      if (getComputedStyle(img).opacity !== '1' || !belowFold(img)) return;
      img.classList.add('alba-fade');
      track(img);
    });
    // Safety net that does not depend on IntersectionObserver: on scroll/resize, reveal whatever is in view
    // (or everything once the page bottom is reached), so content can never stay invisible.
    var check = function () {
      if (!pending.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); return; }
      var h = window.innerHeight, atBottom = h + window.pageYOffset >= document.documentElement.scrollHeight - 4;
      for (var i = pending.length - 1; i >= 0; i--) {
        var el = pending[i], r = el.getBoundingClientRect();
        if (atBottom || (r.top < h - 60 && r.bottom > 0)) { pending.splice(i, 1); io.unobserve(el); reveal(el); }
      }
    };
    var timer = null;
    var onScroll = function () { if (!timer) timer = setTimeout(function () { timer = null; check(); }, 150); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  })();

  /* ---------- Shared helpers for other scripts (alba-pdp.js, alba-cart.js, …) ---------- */
  C.qs = qs; C.qsa = qsa; C.isDesktop = isDesktop; C.findVariant = findVariant;
  C.openModal = openModal; C.changeLine = changeLine; C.initProductMain = initProductMain;
  window.Alba = C;
})();
